module.exports = __webpack_public_path__ + "img/changzhou.48b17aa1.jpg";